import React, { useContext, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import Conversations from './Conversations'
import Filters from './Filters'

import SubscriptionModal from './SubscriptionModal'

import { SearchContext } from '../../store/search-context'
import Spinner from '../UI/Spinner'
import { searchAPI } from '../../services/api/search'
import { getCookie } from '../../utils/common'


const Main = () => {

    const searchCtx = useContext(SearchContext)
    const {uuid} = useParams()

    const [isSubscriptionDetailsLoading, setIsSubscriptionDetailsLoading] = useState(true)
    const [error, setError] = useState('')


    useEffect(()=> {
        // On clicking Edit search subscription
        if(uuid) {
            getSubscriptionDetails(uuid)
        }
    }, [uuid])

    const getSubscriptionDetails = (uuid: string) => {
        setError('')
        setIsSubscriptionDetailsLoading(true)

        const tenantSlug = getCookie('current_tenant')
        searchAPI(tenantSlug).getSingle?.(uuid)
        .then(({filters, conversations, email_notify, name}) => {
            searchCtx.updateFilters(filters)
            searchCtx.updateConversations(conversations)
            searchCtx.updateNotificationPeriodic(email_notify)
            searchCtx.updateName(name)
            setIsSubscriptionDetailsLoading(false)
        })
        .catch(err => {
            setIsSubscriptionDetailsLoading(false)
            setError('Something went wrong. Please try again later.')
            console.log(err);
        })
    }

    return (
        <>
            {
                uuid ?
                    (
                        isSubscriptionDetailsLoading ?
                            <div className="d-flex justify-content-center my-5">
                                <Spinner size="md" />
                            </div> :
                            (error ?
                                error : 
                                <>
                                    <aside className="col-md-3">
                                        {
                                            <Filters />
                                        }
                                    </aside>
                                    <section className="col-md-9">
                                        <Conversations />
                                    </section>
                                </>
                            )
                            
                    ) 
                    :
                    <>
                        <aside className="col-md-3">
                            {
                                <Filters />
                            }
                        </aside>
                        <section className="col-md-9">
                            <Conversations />
                        </section>
                    </>
            }
            <SubscriptionModal />
        </>
    )
}

export default Main
